<template>
  <div class="footer">
   <img src="../assets/img/footer.png" alt="">
   <div class="footer-box">
    <el-row type="flex" class="row-bg" justify="space-around">
  <el-col :span="6">
    <div class="footer-box-1">
      <img class="logo" src="../assets/logo.png" alt="">
    </div></el-col>
  <el-col :span="10">
    <div class="footer-box-2">
        <span>十方星链（苏州）航天科技有限公司</span>
      <li><img src="../assets/img/phone.png" alt=""><a style="color:white" href="tel:010-62488895"> 010-62488895</a> </li>
      <li><img src="../assets/img/email.png" alt=""> <a style="color:white" href="mailto:sfsatlink@sfsatlink.com"> sfsatlink@sfsatlink.com</a> </li>
      <li><img src="../assets/img/position.png" alt=""> 江苏省苏州市相城区青龙港路286号长三角研发启动区10号楼H门1222室      </li>
        <img class="footer-box-2-wx" src="../assets/img/wx.jpg" alt="">
</div>
  </el-col>
  <el-col :span="8">
    <div class="footer-box-3">
     <p> <img src="../assets/img/foot1.png" alt=""> 产品及服务</p>
     <p><span class="footer-box-span" @click=spansclick(1) >天基星座</span><span @click=spansclick(2)>地基终端站</span> <span @click=spansclick(3)>软件研发</span><span @click=spansclick(7)>领域知识</span><span @click=spansclick(9)>航天教育</span></p>
     <p> <img src="../assets/img/foot1.png" alt=""> 解决方案</p>
     <p><span class="footer-box-span" @click=spansclick(5)>卫星建设</span><span @click=spansclick(4)>地基测运控</span> <span @click=spansclick(6) >系统集成</span><span @click=spansclick(8)>星座设计</span><span @click=spansclick(10)>教育赋能</span></p>
    </div></el-col>
</el-row>






   </div>

    <p class="text">Copyright © 2025 十方星链（苏州）航天科技有限公司 ICP备案号 <a style="color:white;margin-left:16px;" href="https://beian.miit.gov.cn">苏ICP备2024124083号</a>  <a href=" " class="iconban" rel="noreferrer" target="_blank" style="color:white;">苏公网安备32050702011816</a >       </p>
  </div>
</template>

<script>
export default {
methods:{
  sendEmail() {
  var mailtoLink = 'mailto:' + encodeURI('recipient@example.com')
    + '?subject=' + encodeURI('Email Subject')
    + '&body=' + encodeURI('Email body text.')
  ;
  window.location.href = mailtoLink;
},
spansclick(num){
  if(num==4){
    this.$router.replace({path:'/solution',query:{id:2}})
  }
  if(num==5){
    this.$router.replace({path:'/solution',query:{id:1}})
  }
  if(num==6){
    this.$router.replace({path:'/solution',query:{id:3}})
  }
  if(num==1){
    this.$router.replace({path:'/product',query:{id:1}})
  }
  if(num==2){
    this.$router.replace({path:'/product',query:{id:2}})
  }
  if(num==3){
    this.$router.replace({path:'/product',query:{id:3}})
  }
  if(num==7){
    this.$router.replace({path:'/product',query:{id:4}})
  }
  if(num==8){
    this.$router.replace({path:'/solution',query:{id:4}})
  }
  if(num==9){
    this.$router.replace({path:'/product',query:{id:5}})
  }
  if(num==10){
    this.$router.replace({path:'/solution',query:{id:5}})
  }
}
}
}
</script>

<style lang="scss" scoped>
.footer {
  width:100%;
  background:#0152a1 ;
  color:white;
  font-size:14px;
  .iconban{
    margin-left:16px;
    padding-left:22px;
    background: url('../assets/img/baicon.png') no-repeat left center !important;;
    background-size:auto 16px !important;
  }
  .text{
    padding-top:50px;
    text-align: center;
    height:100px;
  };
  img{
    width:100%;
    border:0;
  }
  .footer-box{
    background:#0152a1;
    margin-bottom:50px;
    .footer-box-1{
     height: 100%;
     position: relative;
     img{
      width:150px;
      position: absolute;
      top:50%;
      right:10%;
      transform: translateY(-50%)
      }
    }
    .footer-box-2{
      height: 100%;
      position: relative;
      span{
        font-size:18px;
        padding-left:5%;
        margin-bottom:10px;
        display: inline-block;
      }
     li{
      padding-left:5%;
      padding-right:5%;
      vertical-align: middle;
      margin-bottom: 10px;
      white-space: nowrap;      /* 保证文本不会换行 */
      overflow: hidden;         /* 超出容器部分隐藏 */
      text-overflow: ellipsis;  /* 超出文本显示为省略号 */
      img{
        width:20px;
        vertical-align: middle;
      }
     }
     border-left:1px solid white;
     border-right:1px solid white;
     .footer-box-2-wx{
      width:10%;
      position: absolute;
      right:5%;
      top:5%;
     }
    }
    .footer-box-3{
      padding-left:20px;
      height:100%;
      img{
        width:20px;
      }
      span{
        cursor: pointer;
        margin-right:10px;
      }
      .footer-box-span{
        padding-left:23px;
      }
      p:nth-child(1)  {
        font-size:16px;
        margin-bottom: 10px;
      }
      p:nth-child(3)  {
        margin-top:10px;
        font-size:16px;
        margin-bottom: 10px;
      }
    }
  }
}
// 响应式
@media only screen and (max-width: 768px) {
  .footer {
  font-size:10px;
  .logo{
    width:70px !important;
  }
  .footer-box{

  .footer-box-2 span{
    font-size:10px !important;
  }
  .footer-box-3 p{
    font-size:10px !important;
  }
  .footer-box-3 span{
    display: block;
    margin-right: 0 !important;
  }
  .footer-box-span{
    padding-left:0 !important;
  }

}

}
}
</style>
